import React, { useEffect, useState } from "react";
import ReportVolumeTable from "./components/ReportVolumeTable";
import { reportFlareStore } from "src/stores/report-flare-volume-store";
import { useShallow } from "zustand/react/shallow";
import { Spin } from "antd";
import { excelStore } from "src/stores/excel-store.interface";

const ReportFlareFuelVolume = () => {
  const currentYear = new Date().getFullYear();
  const [isDone, setIsDone] = useState(false);

  const loadingCalculateReport = reportFlareStore(useShallow((state) => state.loadingCalculateReport));
  const loadingCalculateReportAfterChangeMaster = reportFlareStore(useShallow((state) => state.loadingCalculateReportAfterChangeMaster));
  const loadingCalculateReportWhenRejectApproval = reportFlareStore(useShallow((state) => state.loadingCalculateReportWhenRejectApproval));
  const setSelectedYearExcel = excelStore(useShallow((state) => state.setSelectedYear));

  useEffect(() => {
    if (!loadingCalculateReport && !loadingCalculateReportAfterChangeMaster && !loadingCalculateReportWhenRejectApproval) {
      setIsDone(true);
    }
  }, [loadingCalculateReport, loadingCalculateReportAfterChangeMaster, loadingCalculateReportWhenRejectApproval]);

  useEffect(() => {
    return () => {
      setSelectedYearExcel(currentYear.toString());
    };
  }, []);
  if (!isDone) return <Spin spinning />;

  return <ReportVolumeTable />;
};

export default ReportFlareFuelVolume;
